<div class="loading-shroud">
  <picture style="height: 15px; margin-bottom: 1rem; opacity: 0.5">
    <source srcset="/assets/zeva-logo-dark-blue.svg" media="(prefers-color-scheme: light)" />
    <source srcset="/assets/zeva-logo-white.svg" media="(prefers-color-scheme: dark)" />
    <img src="/assets/zeva-logo-white.svg" style="height: 100%" fetchpriority="high" />
  </picture>

  @if (isLoggedIn) {
    <img src="/assets/fleet-placeholder.webp" class="placeholder" />
    <p class="status-rotation">
      <span>
        Initializing fleet<br/>
        Connecting all units<br/>
        Scanning systems<br/>
        Loading telemetry<br/>
        Calibrating dashboard<br/>
        Syncing fleet intelligence<br/>
        Unlocking vehicle insights<br/>
        Preparing command centre<br/>
        Fleet systems online<br/>
        Final systems check<br/>
        Ready to deploy
      </span>
    </p>
  }
  @else {
    <shared-loading style="opacity: 0.2; --loading-size: 5rem" />
  }
</div>
